import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Grid, GridColumn, GridDetailRow, GridToolbar } from '@progress/kendo-react-grid';
import './TenderingManager.scss';

import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

class TenderingQuote extends GridDetailRow {

    constructor(){
        super();
       this.state = {
        selectedID: null
        };
    }
   

    componentDidMount(){
       
       
    }

  


    render() {
        const dataItem = this.props.dataItem;
       
       
        return (
            <div className = "TenderingRFQ">
                
               {/* <RFQRequestDetails data = {this.props.dataItem}></RFQRequestDetails> */}
                <Grid 
                ScrollMode="scrollable"
                style={{ height: "600px", width: 'auto'}} 
                 data={dataItem.quoteData.map(
                    (item) => ({ ...item, selected: item.QuotationNumber === this.state.selectedID }))
                }
                // data={dataItem.quoteData}
                 selectedField="selected"
                 onRowClick={(e) => {
                    this.setState({ selectedID: e.dataItem.QuotationNumber });
                    this.props.dataItem.awardQuotation(e.dataItem);
                }}
               >
                    {/* <GridColumn field = "QuotationNumber" title = " " width = "200px"></GridColumn>
                    <GridColumn field = "bidManager" title = " " width = "150px"></GridColumn>
                    <GridColumn field = "maxResponseDuration" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "currencyCode" title = " " width="100px" ></GridColumn>
                    <GridColumn field = "AwardedCarrierData" title = " " width="100px"></GridColumn>
                    <GridColumn field = "RFQ_CARRIER_SCAC" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_PRESELECTED" title = " " width="120px"></GridColumn>
                    <GridColumn field = "QUOT_LIFECYCLE" title = " " width="120px"></GridColumn>
                    <GridColumn field = "QUOT_RESPONSE_CODE" title = " " width = "120px"></GridColumn>
                    <GridColumn field = "QUOT_AMOUNTSUB" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_REJ_REASON_CODE" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_COMMENTS" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_ACC_RESULT" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "YTEND_RESP_STATUS" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_STOP_DATE_FLAG" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "latestFQDueDateTime" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "startDateTime" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "endDateTime" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_SUBMIT_DATETIME" title = " " width = "100px"></GridColumn> */}

                    <GridColumn field = "QuotationNumber" title = " " width = "150px"></GridColumn>
                    <GridColumn field = "bidManager" title = " " width = "150px"></GridColumn>
                    <GridColumn field = "maxResponseDuration" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "currencyCode" title = " " width="100px" ></GridColumn>
                    <GridColumn field = "AwardedCarrierData" title = " " width="100px"></GridColumn>
                    <GridColumn field = "RFQ_CARRIER_SCAC" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_PRESELECTED" title = " " width="120px"></GridColumn>
                    <GridColumn field = "QUOT_LIFECYCLE" title = " " width="120px"></GridColumn>
                    <GridColumn field = "QUOT_RESPONSE_CODE" title = " " width = "120px"></GridColumn>
                    <GridColumn field = "QUOT_AMOUNTSUB" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_REJ_REASON_CODE" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_COMMENTS" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_ACC_RESULT" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "YTEND_RESP_STATUS" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_STOP_DATE_FLAG" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "latestFQDueDateTime" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "startDateTime" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "endDateTime" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_SUBMIT_DATETIME" title = " " width = "100px"></GridColumn>


                  
                </Grid>
            </div>
        );
    }
}

export default TenderingQuote;